import type { User } from '../../../types';

const getStringValue = (value?: string | null) => value?.trim() || '';

export const getAiIncidentUserName = (user?: User | null) => {
  if (!user) {
    return '';
  }

  return [user.firstName, user.lastName].map(getStringValue).filter(Boolean).join(' ') || getStringValue(user.email);
};
